import React from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import SupervisorBankScopeField from '../../components/SupervisorBankScopeField';
import SupervisorBankSearchModal from '../../components/SupervisorBankSearchModal';
import SupervisorMoveDetailView from './SupervisorMoveDetailView';
import {
  fetchSupervisorExpressMonitoring,
  listSupervisedBanks,
  searchSupervisorNullifyTickets,
  searchSupervisorPayTickets,
  searchSupervisorRevertTickets,
  setSupervisorBankPassword,
  supervisorNullifyTicket,
  supervisorPayTicket,
  supervisorRevertTicket,
} from '../../api/supervisor';

// Configurations "portail superviseur" des pages Central de la company
// (2026-09-26) : les pages company (pages/central/*) sont reutilisees telles
// quelles avec SupervisorLayout, des API limitees a SES banks cote backend
// (gatees par SupervisorMenuPermission + 'ticket'/'bank' update) et le champ
// Banque superviseur. Objets CONSTANTS (dependances de hooks stables).

const base = {
  Layout: SupervisorLayout,
  homePath: '/supervisor/dashboard',
  centralPath: '/supervisor/central',
};

export const SUPERVISOR_EXPRESS_PORTAL = {
  ...base,
  fetch: fetchSupervisorExpressMonitoring,
  renderMoveDetail: (props) => <SupervisorMoveDetailView {...props} bankId="" groupId="" />,
};

export const SUPERVISOR_NULLIFY_PORTAL = {
  ...base,
  BankField: SupervisorBankScopeField,
  search: searchSupervisorNullifyTickets,
  action: supervisorNullifyTicket,
};

export const SUPERVISOR_REVERT_PORTAL = {
  ...base,
  BankField: SupervisorBankScopeField,
  search: searchSupervisorRevertTickets,
  action: supervisorRevertTicket,
};

export const SUPERVISOR_PAY_PORTAL = {
  ...base,
  BankField: SupervisorBankScopeField,
  search: searchSupervisorPayTickets,
  action: supervisorPayTicket,
};

// Changer mot de passe POS : banque retrouvee par username OU numero (seq),
// uniquement parmi SES banks.
const findSupervisedBank = async (match) => {
  const banks = await listSupervisedBanks().catch(() => []);
  return banks.find(match) || null;
};

export const SUPERVISOR_PASSWORD_PORTAL = {
  ...base,
  SearchModal: SupervisorBankSearchModal,
  resolveBank: (text) => findSupervisedBank((b) => b.username === text || String(b.seq) === text),
  getBank: async (id) => {
    const bank = await findSupervisedBank((b) => String(b.id) === String(id));
    if (!bank) throw new Error('Banque introuvable');
    return bank;
  },
  setPassword: setSupervisorBankPassword,
};
